<div class="route-details-container table-container">
  <!-- Main header -->
  <div class="main-header">
    <div class="left-header">
      <div>
        <a (click)="goBack()" class="back-navigation">
          <img [src]="SRC.ARROW_LEFT_BLUE" alt="arrow-left" />
          <span class="route-header">{{ CONSTANTS.ROUTE_SUMMARY }}</span>
        </a>
      </div>

      <div class="operation-header">
        {{ CONSTANTS.OPERATIONS }}
      </div>
      <div class="route-details-header">
        {{ CONSTANTS.ROUTE_DETAILS }}
      </div>
    </div>
  </div>

  <ion-col>
    <app-tabs>
      <!-- Details -->
      <app-tab [tabTitle]="CONSTANTS.DETAILS">
        <app-details></app-details>
      </app-tab>

      <!-- Pending Stops -->
      <app-tab [tabTitle]="CONSTANTS.PENDING_STOPS">
        <app-pending-stops> </app-pending-stops>
      </app-tab>
    </app-tabs>
  </ion-col>
</div>
